import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useMsal} from '@azure/msal-react';

import {getLoginStateSelector} from '../../redux/selectors/loginSelector';
import Button from '../../components/form/button/button';
import {assets} from '../../utils/assetsSrc';
import {initLogin, setAzureLogin} from '../../redux/login/loginSlice';
import {loginRequest} from '../../pages/login/authConfig';
import {getUserRoleName} from '../../utils/constants';
import {InteractionStatus} from '@azure/msal-browser';
import './header.scss';
import {toast} from 'react-toastify';
import { useMicrosoftLogin } from '../../hooks/useMicrosoftLogin';

export default function Header() {
  const {inProgress, instance} = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginState = useSelector(getLoginStateSelector());
  const {isLoggedIn, loggedInUser} = loginState;

  /**
   * Handles the Microsoft login flow using the MSAL library.
   * It attempts to log the user in via a popup, acquire an access token,
   * and update the Redux state with the login details.
   */

  const { handleLogin:handleMicrosoftLogin, isLoading, error } = useMicrosoftLogin();

  // const handleMicrosoftLogin = () => {
  //   login((response) => {
  //     // Handle successful login
  //     console.log('Login successful:', response);
  //   });
  // };
  // const handleMicrosoftLogin = async () => {
  //   try {
  //     if (inProgress !== InteractionStatus.None) {
  //       toast.error(
  //         'Login is already in progress. Please complete the open sign-in popup before trying again.',
  //         {
  //           autoClose: 2000,
  //           className: 'toast-error',
  //         },
  //       );
  //       return;
  //     }
  //     // Attempt to login using MSAL's loginPopup method
  //     const loginResponse = await instance.loginPopup(loginRequest);
  //     // console.log('Login successful:', loginResponse);

  //     // Get the active account or the account from the login response
  //     const account = instance.getActiveAccount() || loginResponse.account;

  //     // Attempt to acquire a token silently (without prompting the user)
  //     const tokenResponse = await instance.acquireTokenSilent({
  //       scopes: ['User.Read'], // Scopes needed for Microsoft Graph API (can be adjusted for other APIs)
  //       account: account,
  //     });
  //     // If an access token is acquired, proceed with further actions
  //     if (tokenResponse.accessToken) {
  //       // console.log('Access token acquired:', tokenResponse.accessToken);

  //       // Prepare the payload with the access token
  //       const payload = {
  //         token: tokenResponse.accessToken,
  //       };

  //       // Update Redux state to indicate successful login
  //       dispatch(setAzureLogin(true));  // Set Azure login state to true
  //       dispatch(initLogin(payload));  // Dispatch action to initialize login with the token
  //     }
  //   } catch (error) {
  //     // Log any errors that occur during the login process
  //     console.error('Microsoft login failed:', error);
  //   }
  // };

  return (
    <nav className="navbar">
      <ul className="header-wrapper">
        <li className="logo">
          <img src={assets.komatsuLogo} alt="Logo" />
        </li>
        <li className="buttons">
          {!isLoggedIn ? (
            <>
              <Button
                disabled={loginState?.isLoading}

                // disabled={inProgress !== InteractionStatus.None}
                variant="secondary-button"
                clickHandler={handleMicrosoftLogin}>
                {loginState?.isLoading ? 'Signing in...' : 'Sign in'}
              </Button>
              <Button
                disabled={loginState?.isLoading}
                // disabled={inProgress !== InteractionStatus.None}
                variant="submit-button"
                clickHandler={handleMicrosoftLogin} // Use the same handler for sign-up
              >
                Get Started
              </Button>
            </>
          ) : (
            <div className="user-profile">
              <div>
                <span>{getUserRoleName(loggedInUser?.role) || ''}</span>
                <span>{loggedInUser?.name}</span>
              </div>
              <div>
                <img src={assets.profileIcon} alt="Profile" />
              </div>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
}